/*
  KB Such-Karte (Julien 2026-09-22): Dawns details-modal.js sperrt beim Öffnen
  der Suche das Scrollen der Seite (body.overflow-hidden). Dabei verschwindet
  die Scrollleiste und die Seite springt ~17 px breiter — bei einem Vollbild-
  Modal egal, bei unserer kleinen Karte unter der Lupe sichtbar störend.

  Erste Fassung hat die Sperre im toggle-Event wieder entfernt — das feuert
  aber erst einen Frame später, die Seite „stotterte" kurz (Julien). Deshalb
  jetzt direkt in Dawns open() eingehakt: die Klasse wird im selben Aufruf
  wieder entfernt, bevor der Browser zeichnet. Nur für die Header-Suche;
  andere details-modal-Instanzen behalten Dawns Verhalten. Schließen (Esc,
  Klick daneben, Lupe) bleibt komplett bei Dawn.
*/
(function () {
  customElements.whenDefined('details-modal').then(function () {
    var proto = customElements.get('details-modal').prototype;
    var originalOpen = proto.open;
    proto.open = function (event) {
      originalOpen.call(this, event);
      if (this.classList.contains('header__search')) {
        document.body.classList.remove('overflow-hidden');
      }
    };
  });
})();
